import { render } from "./AIContentList.vue?vue&type=template&id=11beb896&scoped=true"
import script from "./AIContentList.vue?vue&type=script&lang=js"
export * from "./AIContentList.vue?vue&type=script&lang=js"

import "./AIContentList.vue?vue&type=style&index=0&id=11beb896&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11beb896"]])

export default __exports__